<template>
  <div class="app-container" id="app">
    <div class="author">Author: <a href="https://www.malikturk.com/" target="_blank">Malik Türk</a>⚡</div>
    <img src="@/assets/logo.png" alt="">
    <h1 class="title">&lt;vue-tabz /&gt;</h1>
    <div class="title">A Lightweight and flexible underlined tabs component for VueJS ⚡</div>
    <vue-tabz
      :data="tabData"
      max-width="500"
      main-color="#F5BD02"
      @clickedTab="tabsHandler"
    />
    <div v-if="!selectedData.tab" class="data-title">Click on any tab ⚡</div>
    <div v-else class="data-title">
      Selected Tab --
      <code>{{selectedData}}</code>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      tabData: ['one', 'two'],
      selectedData: {},
    }
  },
  methods: {
    tabsHandler(tab) {
      this.selectedData = tab;
    }
  }
}
</script>

<style>
  .app-container {
    font-family: 'Righteous', cursive;
    background-color: rgb(19, 19, 19);
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
  }

  h1.title {
    margin: 0 0 10px;
  }

  .title {
    color: #F5BD02;
    margin-bottom: 50px;
  }

  .data-title {
    margin-top: 20px;
    color: #F5BD02;
  }

  .author, .author a {
    color: #F5BD02;
  }

  .author a {
    text-transform: uppercase;
  }

  .author {
    position: fixed;
    left: 20px;
    bottom: 20px;
  }
</style>
